// get query parameter value from the url
export const getUrlParameter = function (name) {
  if (typeof window !== `undefined`) {
    /* eslint-disable */
    name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
    var results = regex.exec(window.location.search)
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "))
    /* eslint-enable */
  }
  return ""
}

export const getToken = () => {
  if (typeof window !== "undefined") {
    return getUrlParameter("id")
  } else {
    return ""
  }
}

export const clearSessionStorage = () => {
  if (typeof window !== `undefined`) {
    console.log("clearSessionStorage")
    sessionStorage.removeItem("userToken")
    sessionStorage.removeItem("quizProgress")
    sessionStorage.removeItem("sectionLength")
    sessionStorage.removeItem("currentSection")
    sessionStorage.removeItem("userAge")
    sessionStorage.removeItem("userName")
    sessionStorage.removeItem("quizAnswers")
    sessionStorage.removeItem("isFinasteride")
    sessionStorage.removeItem("isMinoxidil")
    sessionStorage.removeItem("isAnswerNoHairHistory")
  }
}

// see https://developer.fastly.com/reference/io/
export const getImgUrlWithSuffix = (url, width) => {
  if (url.includes("?")) {
    return `${url}&width=${width}&auto=webp`
  }
  return `${url}?width=${width}&auto=webp`
}

// Remove cache param from image url (magento hosting cached image bug hack)
export const getNonCachedImageSrc = (url) => {
  // var url = "https://mcstaging.nutrafol.com/media/catalog/product/cache/719c3463fa1b74231c59e96ca31a32f6/3/-/3-pack-refill-balance.png?width=250"
  if (url.indexOf("cache/") > -1) {
    let urlParts = url.split("/")
    let cacheIndex = urlParts.indexOf("cache")
    urlParts.splice(cacheIndex, 2)
    urlParts.splice(0, 2)
    let nonCachedPath = urlParts.join("/")
    return "https://" + nonCachedPath
  }
  return url
}

export const getSectionFromUrl = () => {
 return typeof window !== `undefined` ? window.location.pathname.split('/').filter(Boolean).pop() : "basics"
}

/**
 * Multipurpose caster by timdev
 *
 * cast 70.4 to 70.40
 * remove commas
 * show cents for non-round prices
 * @param price
 * @returns {`$price`}
 */
export const castPrice = (price) => {
  if (typeof price !== "string") {
    price = "" + price
  }
  if (price) {
    const arr = price.replace(",", "").split(".")
    let cents = arr[1] && arr[1].length ? arr[1].slice(0, 2) : ""
    if (cents.length === 1) {
      cents = cents + "0"
    }
    const sfx = cents && cents !== "00" ? "." + cents : ""
    return `$${arr[0] + sfx}`
  }
  return `$${price}`
}

/**
 ** sanitizeForDisplay gets rid of common control characters and different types of whitespace that might not be obvious visually.
 */
export const sanitizeForDisplay = (text = "") => {
  // remove control chars
  const controlCharsRegex =
    // eslint-disable-next-line no-control-regex
    /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F\u00A0\u200B-\u200D\uFEFF\x0A\x0D]/g

  // add target=_blank to all <a> tags
  const anchorRegex = /<a\b(?![^>]*\btarget=)([^>]*)>/gi

  if (!text?.replace) return text

  return text
    .replace(controlCharsRegex, "")
    .replace(anchorRegex, '<a$1 target="_blank" rel="noopener noreferrer">')
}
